import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import {
  Button,
  Input,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Spinner,
} from "reactstrap";
import {
  reopenConversationGet,
  reopenConversationPost,
  reopenConversationRes,
} from "../../../../store/reopenConversation/actions";
import { showToast } from "../../../../Libs/CustomMethods/showToast";

const ReopenConversation = (props) => {
  const { chatId, byManager } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { data, loading, success, error } = useSelector(
    (state) => state.ReopenConversation
  );

  const [modal, setModal] = useState(false);
  const [message, setMessage] = useState("");

  const [nowDate, setNowDate] = useState(new Date());

  const [durationMinutes, setDurationMinutes] = useState(9999);
  const [durationFormatted, setDurationFormatted] = useState("");

  let intervalRef = useRef();

  const toggleModal = (e) => {
    setModal((prev) => (e ? e : !prev));
  };

  const handleReopenConversation = (e) => {
    const body = { message, byManager };
    dispatch(reopenConversationPost(chatId, body));
  };

  const renderButtonContent = () => {
    if (loading) {
      return <Spinner animation="border" size="sm" className="spinner m-0" />;
    } else if (data?.[chatId]?.requestedAt && data?.[chatId]?.status) {
      const status = data[chatId]?.status;
      let color = "text-dark";
      switch (status) {
        case "answered":
        case "accepted":
          color = "text-success";
          break;
        case "no_answer":
        case "rejected":
          color = "text-danger";
          break;
        default:
          break;
      }
      return (
        <>
          <div className={color}>{`${t(`reopen-${status}`)}`}</div>
          {status === "accepted" && (
            <div className={color}>{durationFormatted}</div>
          )}
          <div className={color}>
            {moment(data?.[chatId]?.requestedAt).format("DD/MM/YYYY HH:mm:ss")}
          </div>
        </>
      );
    } else {
      return t("Reopen conversation");
    }
  };

  const updateDate = () => setNowDate(new Date());

  const calulateDiff = (nowR) => {
    var now = moment(nowR);
    var end = moment(data?.[chatId]?.lastStatusAt).add(
      data?.[chatId]?.expirationTime,
      "minutes"
    );
    const duration = moment.duration(end.diff(now));
    const durMinutes = duration.asMinutes();
    const durFormatted = duration.format("mm[m] ss[s]");
    setDurationMinutes(durMinutes);
    setDurationFormatted(durFormatted);
  };

  useEffect(() => {
    const status = data?.[chatId]?.status;
    if (status === "accepted") {
      intervalRef.current = setInterval(updateDate, 1000);
    }
    return () => clearInterval(intervalRef.current);
  }, [chatId, data]);

  useEffect(() => {
    if (durationMinutes <= 0) {
      const object = { [chatId]: { status: "no_answer" } };
      dispatch(reopenConversationGet(chatId));
      dispatch(
        reopenConversationRes(
          { data: object, loading: false, success: "reopenGet" },
          "reopenGet"
        )
      );
    }
  }, [durationMinutes]);

  useEffect(() => {
    calulateDiff(nowDate);
  }, [nowDate]);

  useEffect(() => {
    const status = data?.[chatId]?.status;
    if (status === "accepted" || status === "waiting") {
      // dispatch(reopenConversationGet(chatId));
    }
  }, [chatId]);

  useEffect(() => {
    if (success === "reopenPost") {
      toggleModal(false);
      showToast(t("Reopening request sent successfully"), "success");
    }
    if (error === "reopenPost") {
      showToast(
        t(
          "Error in request to reopen conversation. Please contact our support team"
        ),
        "error"
      );
    }
    dispatch(
      reopenConversationRes({ error: false, loading: false, success: false })
    );
  }, [success, error]);

  return (
    <>
      <div className="p-3 joinChat">
        <Button
          color="light"
          className="w-100 py-3"
          onClick={toggleModal}
          disabled={data?.[chatId]?.requestedAt}
        >
          {renderButtonContent()}
        </Button>
      </div>
      <div>
        <Modal isOpen={modal} toggle={toggleModal}>
          <ModalHeader className="modal-header-no-button">
            {t("Reopen conversation")}
          </ModalHeader>
          <ModalBody>
            <Input
              className="mt-2"
              style={{
                minWidth: "400px",
                minHeight: "100px",
              }}
              type="textarea"
              placeholder={t("Write reopen message here")}
              rows={10}
              onChange={(e) => setMessage(e.target.value)}
            />
          </ModalBody>
          <ModalFooter className="flex-nowrap border-0">
            <button
              type="button"
              onClick={() => toggleModal(false)}
              className="btn btn-dark"
            >
              {t("Cancel")}
            </button>

            <button
              type="button"
              onClick={handleReopenConversation}
              className="btn btn-primary waves-effect waves-light"
            >
              {loading ? <Spinner size="sm" animation="border" /> : t("Send")}
            </button>
          </ModalFooter>
        </Modal>
      </div>
    </>
  );
};

export default ReopenConversation;
